/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { endToEndEncryptionTestEncryptedToken } from "../../funcs/endToEndEncryptionTestEncryptedToken.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.E2EEToken$inboundSchema,
};

export const tool$endToEndEncryptionTestEncryptedToken: ToolDefinition<
  typeof args
> = {
  name: "end-to-end-encryption-test-encrypted-token",
  description:
    `Allows for testing a JWE token to ensure it's acceptable by Moov. 

To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/) 
you'll need to specify the \`/ping.read\` scope.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await endToEndEncryptionTestEncryptedToken(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(void 0, apiCall);
  },
};
